import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import lang from '../../../../lib/language';
import { Payment } from '../../../../lib/models/crm/types';
import { FxOrder } from '../../../../lib/models/reporting/types';
import { RootState } from '../../../../lib/store';
import { usePaymentFxOrders } from '../../../../lib/util/hooks/wallet/PaymentAndFxHook';
import { TextHelpers } from '../../../../lib/util/TextHelpers';

import ArrowBack from '../../../../assets/img/blue_icon-arrow-left.svg';
import { ClickableDiv, ClickableImage } from '../../../../components/index';
import { useIsMobile } from '../../../../hooks';
import MobileFromToDatePicker from '../../../../shared_components/MobileCalendar/MobileFromToDatePicker';
import Modal from '../../modal/paymentsModal/BasicModal';
import FxOrderItem from '../FXOrderItem';
import TransactionItem from '../TransactionItem';

import styles from './TransactionHistory.module.scss';

const TransactionHistory = () => {
  const { isMobile } = useIsMobile();
  const navigate = useNavigate();
  const [infoModal, setInfoModal] = useState({ values: {} });
  const [showModal, setShowModal] = useState<boolean>(false);

  const { hasMorePages, number: pageNumber, setDateRange, setPage, filteredContent } = usePaymentFxOrders();
  const allTransactions = useSelector<RootState, Payment[]>((state: RootState) => state.payment.paymentsAll.data);

  const handleOrderClick = (order: FxOrder) => {
    // TODO impl HW-185
  };

  const handleScroll = () => {
    const windowHeight = window.innerHeight;
    const documentHeight = document.documentElement.scrollHeight;
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const isAtBottom = scrollTop + windowHeight === documentHeight;

    if (isAtBottom) {
      handleButtonLoadMore();
    }
  };

  useEffect(() => {
    isMobile && window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [isMobile]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleButtonLoadMore = () => {
    setPage(pageNumber + 1);
  };

  const handleDateChange = (value) => {
    const { startDate, endDate } = value;
    setDateRange({ startDate, endDate });
  };

  const handleModalTransfer = () => {
    setShowModal(!showModal);
  };

  const handleClick = (payment: Payment) => {
    const values = {
      hasLinkedAccounts: true,
      amount: payment.amount,
      create_date: payment.create_date,
      payment_method: payment.payment_method,
      category: TextHelpers.getPaymentProcessName(payment.payment_process),
      adjustmentCategory: payment.category,
      bankName: payment.sender_bank_name,
      paymentReference: payment.payment_reference,
      paymentStatus: payment.payment_status,
      paymentProcess: payment.payment_process,
      description: payment.description,
      payment,
    };

    setInfoModal({ ...infoModal, values });
    handleModalTransfer();
  };

  return (
    <div className={styles.wrapper}>
      { isMobile && (
      <div className={styles.arrowBack}>
        <ClickableImage
          src={ArrowBack}
          onClick={() => navigate(-1)}
        />
      </div>
      )}
      <div className={styles.titleViewWrapper}>
        <h6 id="transactionsTitle" className={styles.title}>{lang.webFundsTransactionsTitle()}</h6>
        { isMobile && allTransactions.length > 0 && (
        <MobileFromToDatePicker
          label={lang.commonDate()}
          initialState={{
            startDate: new Date(allTransactions[allTransactions.length - 1].create_date),
            endDate: new Date(),
          }}
          maxDateCalendar={new Date()}
          minDateCalendar={new Date(allTransactions[allTransactions.length - 1].create_date)}
          onDateSelect={handleDateChange}
        />
        )}
      </div>
      {isMobile && (
        <div className={styles.itemWrapper}>
          {filteredContent.map((item, index) => {
            if (item.isPayment) {
              const payment:Payment = item.orderOrPayment as Payment;
              return (
                <ClickableDiv key={payment.payment_reference} onClick={() => handleClick(payment)}>
                  <TransactionItem payment={payment} />
                </ClickableDiv>
              );
            }
            const order:FxOrder = item.orderOrPayment as FxOrder;
            return (
              <ClickableDiv id={`transactionsItem_${index}`} key={order.orderId} onClick={() => handleOrderClick(order)}>
                <FxOrderItem fxOrder={order} />
              </ClickableDiv>
            );
          })}
        </div>
      )}
      {isMobile && (
      <>
        {showModal && <Modal handleModal={handleModalTransfer} infoModal={infoModal} />}
      </>
      )}
    </div>

  );
};

export default TransactionHistory;
